<template>
    <div>
        <div @click="back">返回</div>
        <div class="user">个人中心</div>
    </div>
</template>
<script>
export default {
    data(){
        return{}
    },
    methods:{
        back(){
            this.$router.push('/')
        }
    }
}
</script>
<style lang="less" scoped>
.user{
    text-align: center;
    padding-top: 50%;
    color: aqua;
    font-size: 50px;
}
</style>